import Module from "../../../utils/services/project/other/moduleService";
import crudTemplate from "../../../templates/crudTemplate";
let crud = crudTemplate(Module);
function prepareItem(item) {
  item["isActive"] = !!item.activated_at && !item.deactivated_at;
  return item;
}
const state = {
  list: crud.state.list,
  page: crud.state.page
};
const getters = {
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  getList: crud.actions.getList,
  activate(_, { params = {}, onSuccess = () => {}, onError = () => {} }) {
    return Module.activate(params, onSuccess, onError);
  },
  deactivate(_, { params = {}, onSuccess = () => {}, onError = () => {} }) {
    return Module.deactivate(params, onSuccess, onError);
  }
};

const mutations = {
  setList: crud.mutations.setList
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
